module.exports = __webpack_public_path__ + "static/media/cannabis-bud.c92243ee.jpg";